import { codeBidiWarningMessages } from '@atlaskit/editor-common/messages';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { fg } from '@atlaskit/platform-feature-flags';
import { codeBidiWarningPluginKey } from './plugin-key';
import { createBidiWarningsDecorationSetFromDoc as reactCreateBidiWarningsDecorationSetFromDoc, pluginFactoryCreator as reactPluginFactoryCreator } from './react-plugin-factory';
import { createBidiWarningsDecorationSetFromDoc as vanillaCreateBidiWarningsDecorationSetFromDoc, pluginFactoryCreator as vanillaPluginFactoryCreator } from './vanilla-plugin-factory';
export var createPlugin = function createPlugin(api, _ref, _ref2) {
  var dispatch = _ref.dispatch,
    getIntl = _ref.getIntl,
    nodeViewPortalProviderAPI = _ref.nodeViewPortalProviderAPI;
  var appearance = _ref2.appearance;
  var intl = getIntl();
  var codeBidiWarningLabel = intl.formatMessage(codeBidiWarningMessages.label);
  var _ref3 = fg('platform_editor_vanilla_codebidi_warning') ? vanillaPluginFactoryCreator() : reactPluginFactoryCreator(nodeViewPortalProviderAPI),
    createPluginState = _ref3.createPluginState,
    getPluginState = _ref3.getPluginState;
  return new SafePlugin({
    key: codeBidiWarningPluginKey,
    state: createPluginState(dispatch, function (state) {
      var _api$limitedMode;
      if (api !== null && api !== void 0 && (_api$limitedMode = api.limitedMode) !== null && _api$limitedMode !== void 0 && (_api$limitedMode = _api$limitedMode.sharedState.currentState()) !== null && _api$limitedMode !== void 0 && _api$limitedMode.enabled) {
        return {
          decorationSet: DecorationSet.empty,
          codeBidiWarningLabel: '',
          tooltipEnabled: false
        };
      }
      return {
        decorationSet: fg('platform_editor_vanilla_codebidi_warning') ? vanillaCreateBidiWarningsDecorationSetFromDoc({
          doc: state.doc,
          codeBidiWarningLabel: codeBidiWarningLabel,
          tooltipEnabled: true
        }) : reactCreateBidiWarningsDecorationSetFromDoc({
          doc: state.doc,
          codeBidiWarningLabel: codeBidiWarningLabel,
          tooltipEnabled: true,
          nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
        }),
        codeBidiWarningLabel: codeBidiWarningLabel,
        tooltipEnabled: true
      };
    }),
    props: {
      decorations: function decorations(state) {
        var _getPluginState = getPluginState(state),
          decorationSet = _getPluginState.decorationSet;
        return decorationSet;
      }
    }
  });
};